import React, { Component } from 'react'
import cx from 'classnames'
import FileReader from './FileReader'
import { Feedback } from '@softwaredev_cegeka/stix-form'

class FileReaderInput extends Component {
    handleRead = event => {
        event.target.value = event.target.result
        event.target.name = this.props.name
        this.props.onChange && this.props.onChange(event)
        this.props.onBlur && this.props.onBlur(event)
    }

    render() {
        const { className, feedback, isValid, isInvalid, ...rest } = this.props
        let classes = cx(
            `stix-file-upload`,
            {
                [`stix-is-valid`]: isValid,
                [`stix-is-invalid`]: isInvalid,
            },
            className
        )

        return (
            <>
                <div className={classes}>
                    <FileReader
                        onRead={this.handleRead}
                        maxFiles={1}
                        {...rest}
                    />
                </div>
                {feedback ? (
                    <Feedback feedbackType={'invalid'} feedback={feedback} />
                ) : null}
            </>
        )
    }
}

export default FileReaderInput
